<template>
  <div class="page-content conmon-top single-chart">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-content"
             style="padding: 0">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   label-width="95px"
                   class="search-content-item common-search-formtype">
            <el-form-item label="受众类型：">
              <el-select class="ifSelect"
                         @change="modelIdChange"
                         v-model="formInlineTmp.modelId"
                         placeholder="请选择查询内容">
                <el-option v-for="item in audiencesModelOptions"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单图类型：">
              <el-select class="ifSelect"
                         v-model="formInlineTmp.type"
                         placeholder="请选择查询内容">
                <el-option v-for="item in types"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item label="创建人:">-->
            <!--<el-input v-model="formInlineTmp.createrName" placeholder="请输入创建人" clearable></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="单图名称：">
              <el-input @keyup.enter.native="search"
                        v-model.trim="formInlineTmp.singleName"
                        placeholder="请输入单图名称"
                        clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">单图列表</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-dropdown style="float: right"  trigger="click">
            <span class="el-dropdown-link">
          <el-button type="primary"
                     v-if="butsObj.add"
                     class=" add-btn btn-right">
            新建
          </el-button>
      </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="color: #333">
              <span @click="handleToAnayle('/home/customer-analyse')">受众分析</span>
<!--              <router-link style="color: #333" to=""></router-link>-->
            </el-dropdown-item>
            <el-dropdown-item style="color: #333">
              <span @click="handleToAnayle('/home/behavior-analyse')">行为分析</span>
<!--              <router-link style="color: #333" to=""></router-link>-->
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData"
                v-loading="loading">
        <template slot="empty">
          <div class="newTableEmpty">没有更多数据了</div>
        </template>
        <el-table-column prop="modelName"
                         label="受众类型">
        </el-table-column>
        <el-table-column label="单图类型"
                         width="">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">受众分析</span>
            <span v-if="scope.row.type === 2">行为分析</span>
            <span v-if="scope.row.type === 3">漏斗分析</span>
            <span v-if="scope.row.type === 4">订单分析</span>
            <span v-if="scope.row.type === 5">RFM分析</span>
            <span v-if="scope.row.type === 6">复购分析</span>
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         label="单图名称"
                         width="">
        </el-table-column>
        <el-table-column label="修改时间">
          <template slot-scope="scope">{{ scope.row.updateTime }}</template>
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="updateUsrName"-->
        <!--label="创建人">-->
        <!--</el-table-column>-->
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>
        <el-table-column width="130"
                         label="操作"
                         style="display: flex;justify-content: center;">
          <template slot-scope="scope">
            <div class="operation-link">
              <div class="op-link"
                   v-if="butsObj.details"
                   @click="toDetail(scope.row.id, scope.row.filterJson, scope.row.name, scope.row.type)">
                详情
              </div>
              <div class="op-link deleteColor"
                   v-if="butsObj.del"
                   @click="deleteSingle(scope.row.id)">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getMemberLevelList, addMemberLevel, modifyMemberLevel, getMemberLevelDetails, deleteMemberLevel } from '@/api/customer.js'
import { getSingleList, deleteSingle, butonsList, getMenId } from '@/api/analyse.js'
import { getCusTypes } from '@/api/set.js'
export default {
  name: '',
  data () {
    return {
      audiencesModelOptions: [],
      types: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '受众分析',
          value: 1
        },
        {
          label: '行为分析',
          value: 2
        }
      ],
      loading: true,
      editId: '',
      editGradeDialog: false,
      addGradeDialog: false,
      formInlineTmp: {
        modelId: '',
        createrName: '',
        singleName: '',
        type: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      butsObj: { // button按钮列表
        add: false,
        details: false,
        del: false
      }
    }
  },
  methods: {
    modelIdChange () {
      this.getData()
    },
    handleToAnayle (path) {
      let menuListLeft = JSON.parse(localStorage.getItem('menuListLeft')).data || []
      menuListLeft.forEach(item=> {
        let children = item.children || []
        children.forEach(ite=> {
          if (ite.attributes.route === path) {
            Lockr.set('pathNowIndex', item.id)
            localStorage.setItem('pathNowIndex', item.id)
          }
        })
      })
      sessionStorage.setItem('leftPath', path)
      router.push({ path: path})
    },
    // 获取受众类型
    loadCusTypes () {
      getCusTypes().then(res => {
        if (res.data.code === '200') {
          this.formInlineTmp.modelId = 0
          this.getData()
          res.data.result.unshift({
            id: 0,
            name: '全部'
          })
          this.audiencesModelOptions = res.data.result
        }
      })
    },
    toDetail (id, queryJson, name, type) {
      console.log('queryJson', JSON.parse(queryJson))
      if (type === 1) {
        router.push({ path: '/home/customer-analyse', query: { id: id, name: name } })
        sessionStorage.setItem('queryJson', queryJson)
      }
      if (type === 2) {
        router.push({ path: '/home/behavior-analyse', query: { id: id, name: name } })
        sessionStorage.setItem('queryJson', queryJson)
      }
    },
    search () {
      getSingleList(this.page, this.limit, this.formInlineTmp.type, this.formInlineTmp.singleName, this.formInlineTmp.createrName, this.formInlineTmp.modelId).then(res => {
        this.tableData = res.data.result.data
        this.totalCount = res.data.result.total
      })
    },
    closeAddDialogAction () {
      this.addGradeDialog = false
      this.resetForm()
    },
    // 删除单图
    deleteSingle (id) {
      this.$confirm('确认删除此单图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSingle(id).then(res => {
          if (res.data.code === '200') {
            _g.toastMsg('success', res.data.message)
          } else {
            _g.toastMsg('error', res.data.message)
          }
          this.search()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange (page) {
      this.page = page
      this.getData()
    },
    // 获取单图列表
    getData () {
      this.loading = true
      getSingleList(this.page, this.limit, '', '', '', this.formInlineTmp.modelId).then(res => {
        if (res.data.code === '200') {
          this.tableData = res.data.result.data
          this.totalCount = res.data.result.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res => {
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr = result.map((item) => {
            return item.perms
          })
          arrObj.map(it => {
            if (newarr.indexOf(it) !== -1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  created () {
    this.loadCusTypes()
  },
  mounted () {
    this.getButtonsList()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
